export default __webpack_public_path__ + "static/media/live_gift.7712ec2e.png";